(function () {
  "use strict";

  function initialiseSylvaMobileNavigation() {
    var navigation = document.querySelector(
      "[data-sylva-mobile-nav]"
    );

    if (!navigation) {
      return;
    }

    var items = navigation.querySelectorAll(
      ".sylva-lux-nav__item"
    );

    function normalisePath(path) {
      var cleanPath = path.replace(/\/+$/, "");

      return cleanPath === "" ? "/" : cleanPath;
    }

    function detectActiveIndex() {
      var path = normalisePath(
        window.location.pathname
      );

      if (path === "/") {
        return 0;
      }

      if (
        path === "/collections/bestsellers" ||
        path.indexOf("/collections/bestsellers/") === 0
      ) {
        return 2;
      }

      if (
        path === "/collections" ||
        path.indexOf("/collections/") === 0 ||
        path === "/search"
      ) {
        return 1;
      }

      if (
        path.indexOf("/account/login") === 0 ||
        path.indexOf("/account/register") === 0 ||
        path.indexOf("/account/recover") === 0
      ) {
        return 4;
      }

      if (path.indexOf("/account") === 0) {
        return 3;
      }

      return -1;
    }

    function setActiveItem(index) {
      var hasActiveItem =
        index >= 0 &&
        index < items.length;

      navigation.classList.toggle(
        "has-no-active",
        !hasActiveItem
      );

      if (hasActiveItem) {
        navigation.style.setProperty(
          "--active-index",
          String(index)
        );
      }

      items.forEach(function (item) {
        var itemIndex = Number(
          item.getAttribute("data-nav-index")
        );

        var isActive =
          hasActiveItem &&
          itemIndex === index;

        item.classList.toggle(
          "is-active",
          isActive
        );

        if (isActive) {
          item.setAttribute(
            "aria-current",
            "page"
          );
        } else {
          item.removeAttribute(
            "aria-current"
          );
        }
      });
    }

    setActiveItem(detectActiveIndex());

    window.requestAnimationFrame(function () {
      navigation.classList.add("is-ready");
    });

    items.forEach(function (item) {
      item.addEventListener(
        "click",
        function (event) {
          var modifiedClick =
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            event.button !== 0;

          if (modifiedClick) {
            return;
          }

          var destination = item.href;

          if (!destination) {
            return;
          }

          event.preventDefault();

          var index = Number(
            item.getAttribute("data-nav-index")
          );

          setActiveItem(index);

          navigation.classList.add(
            "is-navigating"
          );

          item.classList.remove(
            "is-clicked"
          );

          void item.offsetWidth;

          item.classList.add(
            "is-clicked"
          );

          var itemRect =
            item.getBoundingClientRect();

          var ripple =
            document.createElement("span");

          ripple.className =
            "sylva-lux-nav__ripple";

          var clickX =
            event.clientX > 0
              ? event.clientX - itemRect.left
              : itemRect.width / 2;

          var clickY =
            event.clientY > 0
              ? event.clientY - itemRect.top
              : itemRect.height / 2;

          ripple.style.left =
            clickX + "px";

          ripple.style.top =
            clickY + "px";

          item.appendChild(ripple);

          window.setTimeout(function () {
            ripple.remove();

            item.classList.remove(
              "is-clicked"
            );
          }, 560);

          var reducedMotion =
            window.matchMedia(
              "(prefers-reduced-motion: reduce)"
            ).matches;

          if (reducedMotion) {
            window.location.assign(destination);
            return;
          }

          window.setTimeout(function () {
            window.location.assign(destination);
          }, 100);
        }
      );
    });
  } 

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseSylvaMobileNavigation
    );
  } else {
    initialiseSylvaMobileNavigation();
  }
})();
(function () {
  "use strict";

  function moveShopifyInboxAboveMenu() {
    var shopifyChat = document.querySelector("#ShopifyChat");

    if (!shopifyChat) {
      return false;
    }

    /* Keep the complete Shopify Inbox element above the menu */
    shopifyChat.style.setProperty(
      "z-index",
      "2147483647",
      "important"
    );

    var shadowRoot = shopifyChat.shadowRoot;

    if (!shadowRoot) {
      return false;
    }

    var chatButton = shadowRoot.querySelector(
      "button.chat-toggle"
    );

    if (chatButton) {
      chatButton.style.setProperty(
        "bottom",
        "88px",
        "important"
      );

      chatButton.style.setProperty(
        "z-index",
        "2147483647",
        "important"
      );

      chatButton.style.setProperty(
        "position",
        "fixed",
        "important"
      );
    }

    /*
      Some newer Shopify Inbox versions use a wrapper
      around the activator button.
    */
    var possibleWrappers = shadowRoot.querySelectorAll(
      ".chat-toggle-container, .chat-app--activator, .chat-button-container"
    );

    possibleWrappers.forEach(function (wrapper) {
      wrapper.style.setProperty(
        "bottom",
        "88px",
        "important"
      );

      wrapper.style.setProperty(
        "z-index",
        "2147483647",
        "important"
      );
    });

    return true;
  }

  function initialiseShopifyInboxPosition() {
    var attempts = 0;
    var maximumAttempts = 60;

    var interval = window.setInterval(function () {
      attempts += 1;

      var positioned = moveShopifyInboxAboveMenu();

      if (positioned || attempts >= maximumAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    /*
      Recheck when Shopify Inbox changes its internal DOM.
    */
    var pageObserver = new MutationObserver(function () {
      moveShopifyInboxAboveMenu();
    });

    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener(
      "resize",
      moveShopifyInboxAboveMenu
    );

    window.addEventListener(
      "pageshow",
      moveShopifyInboxAboveMenu
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseShopifyInboxPosition
    );
  } else {
    initialiseShopifyInboxPosition();
  }
})();